/* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';
import * as Yup from 'yup';
import { Button } from 'rsuite';
import { Field, Form, Formik } from 'formik';
import loginService from '../services/login';
import { alert } from '../helpers/rsuite/Alerts';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const msgPassword = 'La contraseña debe tener entre 8 y 20 caracteres, al menos una letra mayúscula, un número y un carácter especial.';

export const FormChangePassword = () => {
    const sessionUser = localStorage.getItem('sessionUser');
    const idUser = JSON.parse(sessionUser).id;
    const [showPassword, setShowPassword] = useState(false);

    const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[[\]/#=?!@$%^&{}()|*+.:,;`'~_-]).{8,}$/;
    const stylesInput = { borderRadius: '6px', border: '1.5px solid #ceced2', width: '100%', height: 40, padding: 7, fontSize: 14, backgroundColor: '#f7f9fa' };
    Yup.addMethod(Yup.string, 'verifyRepeatPassword', function (errorMessage) {
        return this.test('test-validation', errorMessage, function (password, newPasswordVerify) {
            const { path, createError } = this;
            return (
                newPasswordVerify.parent.newPassword === newPasswordVerify.parent.newPasswordVerify || createError({ path, message: 'Las contraseñas no coinciden' })
            );
        });
    });

    const validationSchema = Yup.object({
        password: Yup.string()
            .required('Campo requerido.')
            .min(8, 'Minimo 8 caracteres.')
            .max(20, 'Maximo 20 caracteres.')
            .matches(passwordRegex, msgPassword),
        newPassword: Yup.string()
            .required('Campo requerido.')
            .min(8, 'Minimo 8 caracteres.')
            .max(20, 'Maximo 20 caracteres.')
            .matches(passwordRegex, msgPassword),
        newPasswordVerify: Yup.string()
            .required('Campo requerido.')
            .min(8, 'Minimo 8 caracteres.')
            .max(20, 'Maximo 20 caracteres.')
            .matches(passwordRegex, msgPassword)
            .verifyRepeatPassword('')
    });

    const handleSubmit = (e) => {
        const password = e.password;
        const newPassword = e.newPassword;
        const data = {
            idUser: idUser,
            currentPassword: password,
            password: newPassword,
            idPlatform: '8'

        };

        loginService
            .changePassword(data)
            .then(response => {
                alert('success', 'La contraseña fue cambiada correctamente.');
            })
            .catch(e => {
                alert('error', e.response.data.extra.key === 'password_invalid' ? 'La contraseña es incorrecta.' : 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.');
                console.error(e);
            });
    };

    const handleOnCopy = e => {
        e.preventDefault();
        return false;
    };

    return (
        <>

            <Formik
                initialValues={{ password: '', newPassword: '', newPasswordVerify: '' }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ errors, touched }) => (
                    <Form >
                        <div style={{ width: '70%' }}>
                            <label className="mb-2 mt-10">Contraseña {showPassword ? <VisibilityIcon onClick={() => setShowPassword(false)}/> : <VisibilityOffIcon onClick={() => setShowPassword(true)} />}</label>
                            <Field style={stylesInput} name="password" type={showPassword ? 'text' : 'password'} className="mb-3" fontSize='14px' />
                            { errors.password && touched.password && <p className="errorMsg text-danger">{errors.password}</p>}
                            <label className="mb-3">Contraseña nueva</label>

                            <Field style={stylesInput} name="newPassword" type={showPassword ? 'text' : 'password'} className="mb-3" onCopy={handleOnCopy}/>
                            { errors.newPassword !== undefined && touched.newPassword && <p className="errorMsg text-danger">{errors.newPassword}</p>}

                            <label className="mb-3">Repita nueva contraseña</label>
                            <Field style={stylesInput} name="newPasswordVerify" type={showPassword ? 'text' : 'password'} className="mb-3" />
                            { errors.newPasswordVerify !== undefined && touched.newPasswordVerify && <p className="errorMsg text-danger">{errors.newPasswordVerify}</p>}
                        </div>
                        <hr className='font-weight-bold' style={{ margin: '12px 4px' }} />

                        <Button className='mt-8' type="submit" appearance="primary">
                                Aceptar
                        </Button>
                    </Form>
                )}
            </Formik>
        </>
    );
};
